import React from "react";
export const HidayetDescription = (props: any) => {
    return (
        <div>
            <p>
                <div>HİDAYET : GÖNÜL</div> pusulasının hakikat kıblesini
                yakalama ânıdır. Hidayet, âşıkın maşuka kavuşma hâlidir.
                Hidayet, bir ömür boyu her gün üşenmeden gönül
                penceremize gelip perdelerin aralanmasını bekleyen
                iman güneşinin nazlı nazlı içeri süzülme fırsatıdır.
                Hidayet, dünyada hiçbir nimet ve servetle ölçülemeyen
                ve hatırası bir ömür boyu tüm tazeliğiyle burunda buram
                buram tüten bir mazhariyet sevincidir. Kısacası,
                “hidayet, büyük bir nimet, vicdanî bir lezzet ve ruhun
                cennetidir.”
            </p>
        </div>
    )
}

export const HavraKiliseCamiDescription = (props: any) => {
    return (
        <div>
            <p>
                Elinizdeki çalışma, dünyada İslam’ı seçen bazı din
                adamlarının hidayet öykülerini konu almaktadır. Bu
                zatların her biri, Müslüman olmadan önce birer din
                adamıdır. İstisnasız hepsi de dinlerine adam kazandırmaya
                çalışan birer misyonerdir, hatta bazıları kardinal
                veya başpiskopos seviyesinde yüksek görevlere sahip
                kişilerdir. Acaba böylesine dinlerine bağlı, kendi inançlarına
                başka hayatları davet etmek için çabalayan, bu
                uğura hayatlarını adayan, bu yolda büyük imkân, itibar
                ve üne kavuşmuş olan bu şahıslar neden İslam’ı
                seçtiler?
            </p>
        </div>
    )
}

export const JackieJacksonDescription = (props: any) => {
    return (
        <div>
            <p>
                Cemal Cem’in İslam’la buluşma öyküsünü
                kendisinden dinleyelim:
                Hristiyan anne ve Yahudi bir babanın evladı olarak
                Amerika’da dünyaya geldim. İki yaşımda iken ailem tarafından
                vaftiz edildim. Ailemin beni çok küçük yaşta
                kilise okullarına göndermesiyle Hıristiyanlık eğitimi
                almaya başladım. Yedi yaşına bastığımda diğer çocuklardan
                farklı olduğumu düşünen ailem için bir gurur
                kaynağı idim. Çünkü daha o yaşta, kilisedeki ayinlerde
                papaza, Hz. İsa’nın kanı ve eti diye kabul edilen şarap
                ve ekmeğin sunuluşunda yardım ediyordum. Bu da
                aileme büyük bir övünç veriyor ve babamı geleceğim
                konusunda güzel düşüncelere sevk ediyorlardı.Genç
                yaşta kilise büyükleri tarafından misyoner vaiz olarak
                görevlendirildim.
            </p>
        </div>
    )
}

export const SamuelRichardsDescription = (props: any) => {
    return (
        <div>
            <p>
                Süleyman’ın İslam’la buluşma öyküsünü
                kendisinden dinleyelim:
                Amerika New Jersey’de, Yahudî, dindar ve mutaassıp
                bir anne babadan dünyaya geldim. Küçük yaşlarımdan
                itibaren Yahudîlik dinî terbiyesi üzerine yetiştirildim.
                Yahudî dinî okullarında eğitim gördüm.
                Yetiştirilme tarzım ve aldığım eğitimler sayesinde zamanla
                Yahudilikteki en ince noktaları öğrendim. İlk ve
                lise öğrenimimi prestijli Amerikan okullarında tamamladım.
                Toledo ve Pensilvanya Üniversitelerinde görev
                yaptım. Şu an hâlen Pensilvanya üniversitesinde ders
                vermekteyim. Her yıl uluslararası büyük üniversitelerde
                konferanslar veriyorum. Hamd olsun binlerce öğrencimiz
                var.
            </p>
        </div>
    )
}

export const HathorZemzemDescription = (props: any) => {
    return (
        <div>
            <p>
                (Harvard Üniversitesi Profesörü
                ve Afrika-Kafkas-Ortadoğu Dilleri
                Bölüm Başkanı)
                Zemzem’in İslam’ı seçiş öyküsünü kendinden
                dinleyelim:
                Çek Cumhuriyeti’nde Hıristiyan anneden ve Budist
                babadan dünyaya geldim. Beni çocukken Amerikan
                Hıristiyan bir aileye evlatlık vermişler. Onlar da beni
                Hıristiyan okullarında Hıristiyan inancı üzerine
                yetiştirdiler.
                12 yaşımdan sonra dinlere olan ilgim ve saygım artmaya başladı.
            </p>
        </div>
    )
}

export const IbrahimSahidiDescription = (props: any) => {
    return (
        <div>
            <p>
                (Roma Asıllı Eski Teolog ve Keşiş)
                Son derece mutaassıp Hıristiyan Katolik bir ailenin
                ferdi olarak Roma’da dünyaya geldim. Etrafımızdaki
                her aile gibi benim anne babam da hep bir papaz veya
                keşiş olmamı arzu ederdi. Küçüklüğümden beri ailemin,
                çevremin ve özellikle babamın etkisiyle iyi bir
                Katolik aile terbiyesiyle yetiştim. Zamanla Kilise’de
                yüksek kademelerde hizmet ettim.
                Roma'dan bana verilen görev, misyonerlik faaliyeti
                için Malatya Urfa, Diyarbakır gençlerini hristiyan
                yapmak için beni görevlendirdirler.Sadece bir yıl
                kalabildim.
            </p>
        </div>
    )
}

export const SamiBuhariDescription = (props: any) => {
    return (
        <div>
            <p>
                Yahudi dindar bir anne ve babanın çocuğu olarak İstanbul’da dünyaya geldim. İstanbul’da Galatasaray İlköğretim okulunda ilkokula başladım.
                5. sınıfın bitirme imtihanı esnasında hocam bana bir soru sordu: ”İslam nedir?”  Soruyu duyunca o anda içimde bir şeyler hissettim. Mutlaka Allah bana söyletti.
                Ben de bu soruya karşılık olarak “İslam, güneş gibidir. Nasıl ki güneş doğunca bütün yıldızlar kaybolur İslam da öyle bir şeydir.” dedim.
            </p>
        </div>
    )
}

export const MesihMuratDescription = (props: any) => {
    return (
        <div>
            <p>
                (Tanzanya Piskoposları Eski Reisi)
                Noel Bayramına iki gün kala başpiskopos Martin John Mwaipopo, kilisede ayin yapmak üzere toplanan cemaate Hıristiyanlığı bırakıp Müslüman olacağını ilan etti. Cemaat duyduklarının şokuyla donup kalmıştı.
                Hatta piskopos yardımcısı, makamından fırlayarak kapı ve pencereleri kapatmış ve kilise üyelerine başpiskoposun delirdiğini yüksek sesle ilan etmişti.
            </p>
        </div>
    )
}

export const RecepDescription = (props: any) => {
    return (
        <div>
            <p>
                Küçük yaşlarımdan itibaren kendimi Hıristiyanlık inanç ve terbiyesiyle yetiştiren, üstelik ruhuma İslam’a ve Müslümanlara karşı kin ve düşmanlık tohumlarını eken Katolik bir anne babadan dünyaya geldim.
                Hıristiyanlığı çok seviyordum. Devamlı dini kitaplar okuyup araştırmalarla kendimi bu alanda geliştiriyordum.
                Bu çalışmalarım ve aldığım eğitimler neticesinde Kardinalliğe kadar yükseltildim.
            </p>
        </div>
    )
}

export const SarahSareDescription = (props: any) => {
    return (
        <div>
            <p>
                (Vatikan Basın Danışmanı)
                Vatikan’da doğdum. Katolik bir anne babadan dünyaya geldim. Hıristiyan Katolik terbiyesi üzerine yetiştirildim. İslam’a tamamen zıt fikirlerle donatıldım. Buna kendim de razı değildim.
                Ailem ve hocalarımın teşvikiyle istemeyerek de olsa Hıristiyan gelenek içerisinde yaşamaya çalıştım. Üniversitede Gazetecilik ve Halkla İlişkiler bölümünü bitirdim.
            </p>
        </div>
    )
}

export const MuhammedAliDescription = (props: any) => {
    return (
        <div>
            <p>
                (Arjantinli Yahudî Cemaat Lideri)
                Arjantinli dindar Yahudî bir anne ve babadan dünyaya geldim. İlk dini eğitimimi evimizin yakınında bulunan bir Sinagog’da aldım.
                Zamanımın çoğunu oradaki Hahamlardan ders almakla geçiriyordum. Yahudîliği iyice anlayabilmem için bana İbranîce öğrettiler.
                Küçüklüğümden beri <span className="text-bold">‘Allah’ın dini</span>’nin ayrım yapmaksızın herkesi kuşatan bir din olarak hayal eder ve düşünürdüm.
            </p>
        </div>
    )
}